import React from "react";
import { WizTableForm } from '@/containers/common'
const exam = WizTableForm.Config.exam(this, { apiParams: { } })
const organization = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const position = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const user = WizTableForm.Config.user(this, { apiParams: { state: 1 } })

//配置项
const componentName = "examReport";

function columns() {
  return [
    {
      name: "id",
    },
    {
      title: "考试名称",
      name: "title",
      tableItem: {},
    },
    {
      title: "考试名称",
      name: "examId",
      searchItem: {
        ...exam,
        diy: WizTableForm,
        selectType: 'radio',
        rules: [
          {
            required: true,
            message: '请选择考试名称'
          }
        ]
      },
    },
    {
      title: "学员姓名",
      name: "fullName",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "personIds",
      searchItem: {
        ...user,
        diy: WizTableForm
      }
    },
    {
      title: "学员账号",
      name: "account",
      tableItem: {},
    },
    {
      title: "学员身份证",
      name: "idCard",
      tableItem: {},
    },
    {
      title: "dp账号状态",
      name: "dpAvtiveStatusCn",
      tableItem: {},
    },
    {
      title: "dp人脸识别结果",
      name: "dpAuthenRecordCn",
      tableItem: {},
    },
    {
      title: "账号状态",
      name: "accountState",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      dict: [
        { code: 1, codeName: '激活' },
        { code: 0, codeName: '禁用' }
      ]
    },
    {
      title: "组织类型",
      name: "orgTypeName",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategory",
      dict: {
        wizReplaceData: "orgNodeCategoryTree",
        defalutType: []
      },
      searchItem: {
        type: 'treeselect',
        allowClear: true,
        treeCheckable: true,
        treeCheckStrictly: true
      }
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "上级组织",
      name: "leadName",
      tableItem: {},
    },
    {
      title: "上级组织",
      name: "parentOrgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm
      },
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "岗位",
      name: "positionName",
      tableItem: {},
    },
    {
      title: "岗位",
      name: "positionIds",
      searchItem: {
        ...position,
        diy: WizTableForm
      },
    },
    {
      title: "任职状态",
      name: "jobState",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      dict: [
        { code: 1, codeName: '在职' },
        { code: 0, codeName: '离职' }
      ]
    },
    {
      title: "状态",
      name: "pass",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      dict: [
        { code: 1, codeName: '通过' },
        { code: 0, codeName: '未通过' }
      ]
    },
    {
      title: "考试分类",
      name: "examCategoryName",
      tableItem: {},
    },
    {
      title: "考试类型",
      name: "examType",
      tableItem: {},
      dict: [
        { code: 1, codeName: '课程考试' },
        { code: 0, codeName: '普通考试' }
      ]
    },
    {
      title: "参加考试时间",
      name: "markingDate",
      tableItem: {},
    },
    {
      title: "开始时间",
      name: "startDate",
      tableItem: {},
    },
    {
      title: "结束时间",
      name: "endDate",
      tableItem: {},
    },
    {
      title: "成绩",
      name: "score",
      tableItem: {},
    },
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort:['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            }
          ],
          dataFormat: (v) => {
            let value = Object.assign({}, v)
            if (value['nodeCategory'] && value['nodeCategory'].length) {
              value['nodeCategoryIds'] = value['nodeCategory'].map(nodeCategory => nodeCategory.value)
            } else {
              value['nodeCategoryIds'] = undefined
            }
            return value
          }
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        }
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageList`,
    payload: {
      key: `${componentName}@getPageList`,
      apiParams: { pageNum: 1, pageSize: 10 },
    },
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  orgNodeCategoryTree: {
    path: `organizationNodeCategory/getTypeNodeList`,
    payload: {
      key: `${componentName}@orgNodeCategoryTree`,
      apiParams: {}
    }
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list", "orgNodeCategoryTree"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
